import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import portalSettingsManager from "utils/portalSettingsManager";

export const useStyles = makeStyles((theme: Theme) => ({
  gridContainer: {
    backgroundColor:
      portalSettingsManager?.application?.common.bannerColor || theme.palette.primary.main,
    color: theme.palette.common.white,
    boxSizing: "border-box",
    padding: "10px 10px 10px 24px",
    fontSize: "13px",
    fontWeight: "500",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "-20px",
      marginRight: "-20px",
      marginBottom: "10px",
      width: "calc(100% + 40px)",
      paddingLeft: "20px",
    },
    "& a, & a:visited, & a:hover, & a:active": {
      color: theme.palette.common.white,
    },
    "& a:focus-visible": {
      outline: "2px solid",
      outlineOffset: "2px",
    },
  },
}));
  